import LegalPageLayout from './LegalPageLayout';

function PrivacyPolicy() {
    return <LegalPageLayout nsKey="privacyPolicy" />;
}

export default PrivacyPolicy;
